import { Component, OnInit } from '@angular/core';
import {
  OrganisationPreference,
  OrganisationPreferenceRemoteInterface
} from '@careapp/angular-sdk';
import { BrandingInterface } from '@careapp/angular-sdk/src';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { Organisations } from '../../store/actions';
import * as selectors from '../../store/reducers';

@Component({
  selector: 'ca-org-preferences',
  templateUrl: 'preferences.component.html',
  styleUrls: ['preferences.component.scss']
})
export class PreferencesComponent implements OnInit {
  branding$: Observable<BrandingInterface>;
  preferences$: Observable<OrganisationPreferenceRemoteInterface>;
  loading$: Observable<boolean>;

  constructor(public store: Store<any>) {
    this.preferences$ = this.store.select(selectors.org.currentOrgPreferences);
    this.branding$ = this.store.select(selectors.org.currentOrgBranding);
    this.loading$ = this.store.select(selectors.org.getPreferencesLoading);
  }

  ngOnInit() {
    this.store.dispatch(Organisations.RequestPreferences());
    this.store.dispatch(Organisations.RequestBranding());
  }

  onSaveColors(value) {
    if (value) {
      this.store.dispatch(Organisations.UpdateBrandingColors(value));
    }
  }

  onSavePreferences(value: OrganisationPreference) {
    if (value) {
      this.store.dispatch(Organisations.UpdatePreferences(value));
    }
  }

  onImageRemoved(value: any) {
    this.store.dispatch(Organisations.RemoveBrandingImage(value));
  }

  onColorsReset(value) {
    this.store.dispatch(Organisations.RequestResetBrandingColors());
  }

  onSaveImage(image) {
    if (image) {
      this.store.dispatch(Organisations.UpdateBrandingImage(image));
    }
  }
}
